module.exports = __webpack_public_path__ + "img/PriBlanco1600x800.1b903fd6.png";